import gql from 'graphql-tag';

export const GET_MERCHANT_REVENUE_METRICS = gql`
  query getMerchantRevenueMetrics($params: ReportInput!) {
    merchantRevenueMetrics(params: $params) {
      result {
        day
        venueType
        transactions
        sales
        aov
        cashbackAmount
        campaignFeeAmount
      }
    }
  }
`;

export default GET_MERCHANT_REVENUE_METRICS;
